var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Fragment } from 'react';
import cx from 'classnames';
import { ErrorOutlineIcon, CheckmarkIcon } from '@move-ui/icons-asset-catalog';
import Text, { TextSize } from '@move-ui/text';
import { Input } from '../Input/Input';
import { Label } from '../Label/Label';
import styles from './InputItem.module.css';
var renderInput = function (_a) {
    var inputProps = _a.inputProps, disabled = _a.disabled, isValid = _a.isValid, className = _a.className, value = _a.value, inputRef = _a.inputRef, rest = __rest(_a, ["inputProps", "disabled", "isValid", "className", "value", "inputRef"]);
    return (React.createElement(Input, __assign({}, inputProps, rest, { disabled: disabled, isValid: isValid, className: className, "aria-invalid": !isValid, value: value, inputRef: inputRef })));
};
export var InputItem = function (_a) {
    var _b, _c, _d;
    var className = _a.className, label = _a.label, errorMessage = _a.errorMessage, isLabelScreenReaderOnly = _a.isLabelScreenReaderOnly, _e = _a.isValid, isValid = _e === void 0 ? true : _e, disabled = _a.disabled, applySuccessState = _a.applySuccessState, _f = _a.renderInputComponent, renderInputComponent = _f === void 0 ? renderInput : _f, value = _a.value, inputRef = _a.inputRef, preactFor = _a.preactFor, labelClassName = _a.labelClassName, inputProps = __rest(_a, ["className", "label", "errorMessage", "isLabelScreenReaderOnly", "isValid", "disabled", "applySuccessState", "renderInputComponent", "value", "inputRef", "preactFor", "labelClassName"]);
    var showError = !(isValid || disabled) && !!errorMessage;
    var id = inputProps.id;
    var isSuccessful = applySuccessState && isValid && !disabled && !!value;
    var withLabel = !isLabelScreenReaderOnly && label;
    return (React.createElement("div", { className: cx(styles.container, className) },
        renderInputComponent({
            inputProps: __assign(__assign({}, inputProps), { children: (React.createElement(Fragment, null,
                    React.createElement(Label, { htmlFor: id, className: cx(styles.label, (_b = {},
                            _b[styles.withIconLeft] = inputProps.iconLeft,
                            _b[styles.withIconRight] = inputProps.iconRight || inputProps.onClear,
                            _b), labelClassName), isScreenReaderOnly: isLabelScreenReaderOnly, applyDisabledStyle: disabled, preactFor: preactFor, showError: showError, errorMessage: errorMessage }, label || ''),
                    isSuccessful && (React.createElement(CheckmarkIcon, { className: cx(styles.checkmarkIcon, (_c = {},
                            _c[styles.withLabel] = withLabel,
                            _c[styles.withIconLeft] = inputProps.iconLeft,
                            _c)) })))) }),
            disabled: disabled,
            value: value,
            isValid: isValid,
            isSuccessful: isSuccessful,
            className: cx(styles.input, (_d = {}, _d[styles.withLabel] = withLabel, _d)),
            inputRef: inputRef
        }),
        showError && (React.createElement("div", { id: "".concat(id, "-errorMessage"), className: styles.errorMessage },
            React.createElement(ErrorOutlineIcon, { className: styles.errorIcon }),
            React.createElement(Text, { size: TextSize.XXS, color: "emotion-200" }, errorMessage)))));
};
//# sourceMappingURL=InputItem.js.map